// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c069863b","732":"31bb1622","939":"5df86ecd","977":"20a0da01"}[chunkId] + ".chunk.js";
};